import clsx from "clsx";
import React from "react";
import _ from "lodash";

import {useParams} from "react-router-dom";
import { connect } from 'react-redux';

import withStyles from "@material-ui/core/styles/withStyles";
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import ArrowBack from '@material-ui/icons/ArrowBack';
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from "@material-ui/core/Grid";
import {Skeleton} from "@material-ui/lab";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {Divider} from "@material-ui/core";

import PrimaryButton from "../../../../../../../components/Buttons/PrimaryButton";
import StepFooter from "../../StepFooter";
import SliderFormElement from "../../formElement/SliderFormElement";
import styles from "../styles";
import {QuestionnairesHandlerResource} from "../../../../../../../utils/api";
import { downloadPdf } from "../../../../../../../utils/utils";
import { setProductSelectionSRRI } from '../../../../../actions'
import { displayErrorSnackBar } from '../../../../../../../components/SnackbarProvider/actions'
import {getDanteCustomerFullName} from "../../../../../utils";
import {SAVE_AND_CONTINUE_BTN_LABEL} from "../../../../../constants";
import InfoCard from "../DynamicStep/components/InfoCard";
import RiskProfileSlider from "./components/RiskProfileSlider";
import BaseDialog from "../../../../../../../components/BaseDialog/BaseDialog";
import ResendResultButton from "../../StepFooter/components/ResendResultButton";
import {GREY_INFO_COLOR} from "../../../../../../../themes/themeConfigurator";
import RiskProfileCategoryCard from "./components/RiskProfileCategoryCard";


const mapStateToProps = (state) => ({
  auth: state.get('auth').toJS(),
});

export const getSRRICategory = (srri) => {
  const low = [1,2];
  const medium = [3,4,5];
  const high = [6,7];

  if (low.includes(srri)) return "Defensiv";
  else if (medium.includes(srri)) return "Moderat";
  else if (high.includes(srri)) return "Offensiv";
  return 'Unbekannt';
};

const NO_PROFILE_INFO = 'Für diesen Kunden/ diese Kundin wurde noch keine Anlagestrategie festgelegt, da noch nicht alle Pflichtangaben für die Risikoprofilierung vorliegen. Bitte vervollständigen Sie diese, um das Risikoprofil zu ermitteln.';

const values = [1, 2, 3, 4, 5, 6, 7];
const min = 0;
const marks = values.map((value, index) => ({
  value: 100 / (values.length - 1) * index,
  label: value
}));
const step = 100 / (values.length - 1);

const categoryForSubtitle = {
  "Moderat": "moderate"
};

const SriTextsBlock = (props) => {
  const {
    classes,
    normal_value,
    newDesign,
  } = props;

  const [srriTexts, setSrriTexts] = React.useState({});

  React.useEffect(() => {
    QuestionnairesHandlerResource.at('get-srri-texts/').get().then(res => setSrriTexts(res));
  }, []);

  return (
    <>
      <Grid item xs={12}>
        Bei der Ermittlung des Risikoprofils greifen viele Faktoren ineinander und beeinflussen sich gegenseitig:
      </Grid>

      {srriTexts && (srriTexts[normal_value.toString()] || []).map((text, idx) => (
        <Grid item xs={12} key={idx}>
          <div className={clsx(classes.finalListItem, newDesign && 'newDesign')}>{text}</div>
        </Grid>
      ))}
      {!srriTexts && (
        <>
          <Grid item xs={12}><Skeleton /></Grid>
          <Grid item xs={12}><Skeleton /></Grid>
          <Grid item xs={12}><Skeleton /></Grid>
        </>
      )}

      <Grid item xs={12}>
        Das Risikoprofil des/der Kunden/in wurde mit den Risikoeinstufungen der Produkte gemäß SRI
        gleichgesetzt, wobei 1 das niedrigste und 7 das höchste Risiko ausdrückt.
      </Grid>
    </>
  )
};

const FinalStep = props => {
  const {
    classes,
    uid,
    name,
    help_text,
    questions,
    loading,
    onPrevClick,
    onResendResultClick,
    onConfirmResultClick,
    onAnswerChange,
    dataService,
    extraRightButtons,
  } = props;

  let { customer_id } = useParams();

  const [questionnaireFileDownloadingProgress, setQuestionnaireFileDownloadingProgress] = React.useState(false);
  const [sriExplanationOpen, setSriExplanationOpen] = React.useState(false);

  const question = questions[0];
  const isNewDesign = dataService.isNewDesign;
  const normal_value = typeof question.answer === 'number' ? question.answer : question.value;
  const noProfile = _.isNil(normal_value);
  const max = (question.value - 1) * step || 1; // workaround for max = 0 to prevent slider width = 0

  props.dispatch(setProductSelectionSRRI(normal_value));

  const value = noProfile ? undefined : (normal_value - 1) * step;
  const sliderStyle = {
    position: 'absolute',
    left: `${min}%`,
    right: `${noProfile ? min : (100 - max)}%`,
    top: 0,
    width: 'auto'
  };

  if(noProfile){
    sliderStyle.color = 'transparent';
  }

  let category = getSRRICategory(normal_value);

  const getSelectedMark = (value) => {
    return marks && marks.find(item => item.value === value);
  };

  const handleChange = (value) => {
    const mark = getSelectedMark(value);
    if(mark){
      const answer = mark.value / step + 1;
      onAnswerChange(question.uid, answer);
    }
  };

  const handleConfirmClick = () => {
    onConfirmResultClick({suggested_srri: question.value, srri: normal_value})
    props.dispatch(setProductSelectionSRRI(normal_value))
  };

  const handlePdfDownload = () => {

    let requestBody = {
      customer_id,
      session_id: dataService.onboarding_uid,
      questionnaire_session_id: dataService.session_id,
    }

    setQuestionnaireFileDownloadingProgress(true)

    downloadPdf(`/reports/onboarding/questionnaire-pdf/`, undefined, 'POST', undefined, requestBody)
    .then(() => setQuestionnaireFileDownloadingProgress(false))
    .catch(error => {
      setQuestionnaireFileDownloadingProgress(false)
      props.dispatch(displayErrorSnackBar("Fehler bei der PDF-Erstellung"))
    });
  };

  React.useEffect(() => {
    if (!question.answer) {
      onAnswerChange(question.uid, normal_value);
    }
  }, []);

  const BackButton = (
    <PrimaryButton
      text={"Zurück"}
      icon={<ArrowBack color={'primary'}/>}
      variant={"outlined"}
      onButtonClick={onPrevClick}
    />
  );

  const ResendResultButtonEl = (
    <ResendResultButton
      name={"Risikoprofil"}
      isNewDesign={isNewDesign}
      onResendResultClick={onResendResultClick}
    />
  );

  const ConfirmResultButton = (
    <PrimaryButton
      text={noProfile ? SAVE_AND_CONTINUE_BTN_LABEL : "Bestätigen"}
      onButtonClick={handleConfirmClick}
    />
  );

  const questionInfo = noProfile ? NO_PROFILE_INFO : question.info;
  const customerName = getDanteCustomerFullName(dataService.current_customer);
  const showSRIDialog = () => setSriExplanationOpen(true);

  let rightButtons;
  if(isNewDesign){
    const extraBtnsCopy = [...extraRightButtons];
    const backBtn = extraBtnsCopy.pop();  // last btn should be back btn
    rightButtons = [...extraBtnsCopy, ResendResultButtonEl, backBtn, ConfirmResultButton];
  } else {
    rightButtons = [...extraRightButtons, ResendResultButtonEl, ConfirmResultButton];
  }

  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepScrollContainer}>
        <div className={clsx(classes.stepContent, 'app-page-container')}>
          {isNewDesign ? (
            <Grid container spacing={4}>
              <Grid item xs={12} md={true}>
                <Grid container spacing={2}>
                  <Grid item xs={12} className={classes.stepName} data-id={`${uid}-name`}>
                    Risikoprofil von {customerName}
                  </Grid>
                  {!!questionInfo && <InfoCard uid={uid} info_text={questionInfo} isNewDesign cardType={noProfile ? 'warning' : 'info'} />}
                  <Grid item xs={12} style={{marginTop: 64, marginLeft: 30, marginRight: 30, height: 90, position: 'relative'}}>
                    <RiskProfileSlider
                      disabled={question.disabled || noProfile}
                      sri={normal_value}
                      maxSRI={question.value}
                      noProfile={noProfile}
                      onChange={(value) => onAnswerChange(question.uid, value)}
                    />
                  </Grid>
                  {!noProfile && <SriTextsBlock classes={classes} normal_value={normal_value} newDesign />}
                  <Grid item xs={12}>
                    <PrimaryButton
                      text={'Mehr zur Risikoklassen-Zuordnung'}
                      variant={'text'}
                      icon={<i className={'fal fa-external-link'} />}
                      iconPosition={'right'}
                      onButtonClick={showSRIDialog}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={'auto'}>
                <Grid container spacing={2} className={classes.riskProfileCard}>
                  <RiskProfileCategoryCard category={category} />
                  {help_text && !noProfile && (
                    <>
                    <Grid item xs={12} data-id={`${uid}-help`}>
                      {help_text.replace('{risk_category}', (categoryForSubtitle[category] || category).toLowerCase())}
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Grid container justify={"space-between"} style={{fontSize: 18}}>
                          <div>Risikoklasse</div>
                          <div>{normal_value || <i className={'fal fa-question-circle'} style={{color: GREY_INFO_COLOR}}/>}</div>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        Risikoeinstufung gemäß
                        <PrimaryButton
                          text={'SRI'}
                          variant={'text'}
                          icon={<i className={'fal fa-external-link'} />}
                          iconPosition={'right'}
                          onButtonClick={showSRIDialog}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}><Divider/></Grid>
                  <Grid item xs={12}>
                    <PrimaryButton
                      text={"Risikoprofil PDF"}
                      icon={questionnaireFileDownloadingProgress ? <CircularProgress style={{color: 'rgba(0, 0, 0, 0.26)'}} size={15}/> : <SaveAltIcon />}
                      onButtonClick={handlePdfDownload}
                      disabled={noProfile}
                      customClasses={{root: classes.pdfBtn}}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <BaseDialog
                title={'SRI – Risikoklassen'}
                open={sriExplanationOpen}
                handleClose={() => setSriExplanationOpen(false)}
                customClasses={{dialogContent: classes.dialogContentSRI}}
              >
                <Table className={classes.table}>
                  <TableRow className={classes.tableHeader}>
                    <TableCell>SRI</TableCell>
                    <TableCell>Beschreibung</TableCell>
                    <TableCell>Empfohlener Anlagehorizont</TableCell>
                    <TableCell>Verlustrisiken</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>1</TableCell>
                    <TableCell>Wertpapiere mit sehr geringer Schwankungsbreite aus dem Bereich Geldmarkt, sehr kurz
                      laufender Renten- und Garantieprodukte
                    </TableCell>
                    <TableCell>1 Jahr und länger</TableCell>
                    <TableCell>sehr geringe Kapitalverluste</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>2</TableCell>
                    <TableCell>Wertpapiere mit geringer Schwankungsbreite aus dem Bereich kurz und mittel laufender
                      Rentenprodukte
                    </TableCell>
                    <TableCell>3 Jahre und länger</TableCell>
                    <TableCell>geringe Kapitalverluste</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>3</TableCell>
                    <TableCell>Wertpapiere mit geringer bis mittlerer Schwankungs-breite aus dem Bereich mittel und
                      lang laufender Rentenprodukte, Misch- und Dachfonds defensiv
                    </TableCell>
                    <TableCell>5 Jahre und länger</TableCell>
                    <TableCell>Verlustrisiken aus Aktien-, Zins- und Währungsschwankungen</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>4</TableCell>
                    <TableCell>Wertpapiere mit mittlerer Schwankungsbreite aus dem Bereich lang laufender
                      Rentenprodukte, Misch-, Dachfonds ausgewogen/dynamisch und Aktienfonds (Standardwerte Europa/Welt)
                    </TableCell>
                    <TableCell>5 Jahre und länger</TableCell>
                    <TableCell>Verlustrisiken aus Aktien-, Zins- und Währungsschwankungen</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>5</TableCell>
                    <TableCell>Wertpapiere mit erhöhter Schwankungsbreite aus dem Bereich spekulativer Rentenprodukte,
                      spekulativer Dach- und Mischfonds, Aktienfonds Welt (Standardwerte Einzelländer/Emerging Markets;
                      mittlere & kleinere Werte; Branchen)
                    </TableCell>
                    <TableCell>7 Jahre und länger</TableCell>
                    <TableCell>höhere Verlustrisiken aus Aktien-, Zins- und Währungsschwankungen</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>6</TableCell>
                    <TableCell>Wertpapiere mit hoher Schwankungsbreite aus dem Bereich Aktienfonds Welt
                      (Standardwerte Einzelländer/Emerging Markets; mittlere und kleinere Werte; Branchen)
                    </TableCell>
                    <TableCell>7 Jahre und länger</TableCell>
                    <TableCell>höhere Verlustrisiken aus Aktien-, Zins- und Währungsschwankungen</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>7</TableCell>
                    <TableCell>Wertpapiere mit sehr hoher Schwankungsbreite aus dem Bereich Aktienfonds Welt
                      (Einzelländer/Emerging Markets; mittlere und kleinere Werte; Branchen mit hohem Risiko);
                      Beteiligungen mit Nachschussverpflichtungen
                    </TableCell>
                    <TableCell>10 Jahre und länger</TableCell>
                    <TableCell>sehr hohe Verlustrisiken aus Aktien-, Zins- und Währungsschwankungen bis Totalverlust</TableCell>
                  </TableRow>
                </Table>
              </BaseDialog>
            </Grid>
          ) : (
            <>
              <div className={classes.stepName} data-id={`${uid}-name`}>
                {name.replace('{customer_name}', customerName).replace('{risk_category}', category)}
              </div>
              {help_text && (
                <div className={classes.stepHelpText} style={{
                  textAlign: 'center',
                }} data-id={`${uid}-help`}>
                  {help_text.replace('{risk_category}', (categoryForSubtitle[category] || category).toLowerCase())}
                </div>
              )}
              <div className={classes.finalContent}>
                <div>
                  <h3>Risikoklasse: {normal_value || '-'}</h3>
                  <div className={classes.stepInfoText} style={{
                    fontFamily: 'Roboto-Regular',
                    marginBottom: 80
                  }}>
                    {questionInfo && (
                      <span>
                        <span className='far fa-info-circle' />
                        &nbsp;
                        {questionInfo}
                      </span>
                    )}
                  </div>
                  <div style={{position: 'relative', height: 60}}>
                    <SliderFormElement
                      disabled={question.disabled}
                      value={value}
                      step={step}
                      marks={marks}
                      min={min}
                      max={max}
                      onChange={handleChange}
                      style={sliderStyle}
                      isRiskStep={true}
                    />
                  </div>
                  <div className={classes.finalSliderLabels}>
                    <div className={clsx(category === "Defensiv" && classes.finalActiveLabel)}><span>Defensiv:</span><br/><span>1 - 2</span></div>
                    <div className={clsx(category === "Moderat" && classes.finalActiveLabel)}><span>Moderat:</span><br/><span>3 - 5</span></div>
                    <div className={clsx(category === "Offensiv" && classes.finalActiveLabel)}><span>Offensiv:</span><br/><span>6 - 7</span></div>
                  </div>
                </div>

                <Grid container spacing={2} style={{fontSize: 16}}>
                  <Grid item xs={12} className={classes.finalPdfButtonWrap}>
                    <PrimaryButton
                      text={"Risikoprofil als PDF herunterladen"}
                      icon={questionnaireFileDownloadingProgress ? <CircularProgress style={{color: 'rgba(0, 0, 0, 0.26)'}} size={15}/> : <SaveAltIcon />}
                      onButtonClick={handlePdfDownload}
                    />
                  </Grid>
                  <SriTextsBlock classes={classes} normal_value={normal_value} />
                </Grid>
              </div>
            </>
          )}
          <div className={classes.scrollFix} />
        </div>
      </div>

      <StepFooter
        leftItems={!isNewDesign && [BackButton]}
        rightItems={rightButtons}
      />
    </div>
  );
};

export default connect(mapStateToProps)(withStyles(styles)(FinalStep));
